/**
 * 基础菜单 大数据
 */
<template>
  <div>
    <!-- 面包屑导航 -->
    <el-breadcrumb separator-class="el-icon-arrow-right">
      <el-breadcrumb-item :to="{ path: '/' }">首页</el-breadcrumb-item>
      <el-breadcrumb-item>商务合作</el-breadcrumb-item>
    </el-breadcrumb>
    <el-form label-width="160px" class="mobile-form" :model="editForm" :rules="rules" ref="editForm">

      <el-form-item label="公司地址" prop="companyaddress">
        <el-input @input="awdojo()" size="small" v-model="editForm.companyaddress" auto-complete="off" placeholder="公司地址"></el-input>
      </el-form-item>
      <el-form-item label="公司名称" prop="companyname">
        <el-input @input="awdojo()" size="small" v-model="editForm.companyname" auto-complete="off" placeholder="公司名称"></el-input>
      </el-form-item>
 <el-form-item label="联系电话" prop="contactnumber">
   <el-input @input="awdojo()" size="small" v-model="editForm.contactnumber" auto-complete="off" placeholder="联系电话"></el-input>
 </el-form-item>
 <el-form-item label="联系人" prop="contactperson">
   <el-input @input="awdojo()" size="small" v-model="editForm.contactperson" auto-complete="off" placeholder="联系人"></el-input>
 </el-form-item>
      <el-form-item label="主图" prop="img">
        <template slot-scope="scope">
          <el-upload
            class="avatar-uploader"
            :action="baseUrl+'/api/user/uploads'"
            :show-file-list="false"
            :on-success="handleAvatarSuccess"
            :before-upload="beforeAvatarUpload">
            <img v-if="editForm.img" :src="editForm.img" class="avatar">
            <i v-else class="el-icon-plus avatar-uploader-icon"></i>
          </el-upload>
         </template>
      </el-form-item>
 <el-button size="small" type="primary" :loading="loading" style="margin-left: 20%;" class="title" @click="submitForm('editForm')">保存</el-button>

    </el-form>



    <!-- 编辑界面 -->

  </div>
</template>

<script>
import { Business, BusinessSave, brandDelete,sortlist } from '../../api/userMG'
import Pagination from '../../components/Pagination'
import Tinymce from "@/components/Tinymce";
export default {
  data() {
    return {
      flag:0,
      deleteList:[],
      baseUrl : "",
      brandListData:{},//分类列表
      nshow: true, //switch开启
      fshow: false, //switch关闭
      loading: false, //是显示加载
      editFormVisible: false, //控制编辑页面显示与隐藏
      title: '添加',
      editForm: {
        token: localStorage.getItem('logintoken'),
        companyaddress:'',
        companyname :'',
        img : '',
        img1 : '',
        contactnumber : '',
        contactperson : '',
        ids :""

      },
      // rules表单验证
      rules: {
        companyaddress: [
          { required: true, message: '公司地址', trigger: 'blur' }
        ],
        companyname: [
          { required: true, message: '公司名称', trigger: 'blur' }
        ],
        contactnumber: [
          { required: true, message: '联系电话', trigger: 'blur' }
        ],
        contactperson: [
          { required: true, message: '联系人', trigger: 'blur' }
        ]

      },
      formInline: {
        page: 1,
        limit: 10,
        varLable: '',
        varName: '',
        token: localStorage.getItem('logintoken')
      },
      // 删除部门
      seletedata: {
        ids: '',
        token: localStorage.getItem('logintoken')
      },
      userparm: [], //搜索权限
      listData: [], //用户数据
      // 分页参数
      pageparm: {
        currentPage: 1,
        pageSize: 10,
        total: 10
      }
    }
  },
  // 注册组件
  components: {
    Pagination,Tinymce
  },
  /**
   * 数据发生改变
   */

  /**
   * 创建完毕
   */
  created() {
    this.getdata(this.formInline)
    this.baseUrl=this.$config.baseUrl
  },

  /**
   * 里面的方法只有被调用才会执行
   */
  methods: {
      handleSelectionChange(val) {
              this.deleteList=val

            },



      handleAvatarSuccess(res, file) {
              this.editForm.img = URL.createObjectURL(file.raw);
              this.editForm.img1=res
              this.$message.success("上传成功");
              this.$forceUpdate()
           },
       beforeAvatarUpload(file) {
         const isJPG = file.type === 'image/jpeg' || file.type === 'image/png';

         if (!isJPG) {
           this.$message.error('上传头像图片只能是 JPG或者PNG 格式!');
          return isJPG ;
         }
         else{
           this.$message.warning("上传中");

           return isJPG ;
         }

       },
      asdw(e){
        console.log(e);
      },
      awdojo(){
        this.$forceUpdate()
      },


    // 获取公司列表
    getdata(parameter) {
      this.loading = true
      /***
       * 调用接口，注释上面模拟数据 取消下面注释
       */
      Business(parameter)
        .then(res => {
          this.loading = false

          this.editForm = res
        })
        .catch(err => {
          this.loading = false
          this.$message.error('菜单加载失败，请稍后再试！')
        })
    },
    // 分页插件事件
    callFather(parm) {
      this.formInline.page = parm.currentPage
      this.formInline.limit = parm.pageSize
      this.getdata(this.formInline)
    },
    // 搜索事件
    search() {
      this.getdata(this.formInline)
    },
    //显示编辑界面
    handleEdit: function(index, row) {
      this.flag=this.flag + 1;
      this.editFormVisible = true
      if (row != undefined && row != 'undefined') {
        this.title = '修改'
        this.editForm.ids = row._id.$oid
        this.editForm.name = row.name
        this.editForm.phone = row.phone
        this.editForm.image = row.image
        this.editForm.image1 = ''
        this.editForm.class = row.class
        this.$set(this.editForm,"content", row.content)

      } else {
        this.title = '添加'
        this.editForm.ids = ''
        this.editForm.name = ''
        this.editForm.phone = ''
        this.editForm.image = ''
        this.editForm.class = ''
        this.$set(this.editForm,"content", '')
        this.editForm.image1 = ''
      }
    },
    // 编辑、增加页面保存方法
    submitForm(editData) {


     this.editForm._id = this.editForm._id.$oid
      this.$refs[editData].validate(valid => {
        if (valid) {
          BusinessSave(this.editForm)
            .then(res => {
              this.editFormVisible = false
              this.loading = false
              if (res.success) {
                this.getdata(this.formInline)
                this.$message({
                  type: 'success',
                  message: '保存成功！'
                })
              } else {
                this.$message({
                  type: 'info',
                  message: res.msg
                })
              }
            })
            .catch(err => {
              this.editFormVisible = false
              this.loading = false
              this.$message.error('保存失败，请稍后再试！')
            })
        } else {
          return false
        }
      })
    },
    delList(){
      let List = this.deleteList
        if (List.length == 0){
          this.$message.error('请选择删除的数据')
          return
        }
      this.$confirm('确定要删除吗?', '信息', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(() => {

      for (let i in List) {

          this.deleteUserList(i,List[i])
      }
       this.getdata(this.formInline)
      }).catch(() => {
          this.$message({
            type: 'info',
            message: '已取消删除'
          })
        })

    },
    deleteUserList(index, row) {

          brandDelete(row._id.$oid)
            .then(res => {
              if (res.success) {
                this.$message({
                  type: 'success',
                  message: '已删除!'
                })

              } else {
                this.$message({
                  type: 'info',
                  message: res.msg
                })
              }
            })
            .catch(err => {
              this.loading = false
              this.$message.error('删除失败，请稍后再试！')
            })
    },
    // 关闭编辑、增加弹出框
    closeDialog() {
      this.editFormVisible = false
    }
  }
}
</script>

<style scoped>
  .avatar-uploader .el-upload {
      border: 1px dashed #d9d9d9;
      border-radius: 6px;
      cursor: pointer;
      position: relative;
      overflow: hidden;
    }
    .avatar-uploader .el-upload:hover {
      border-color: #409EFF;
    }
    .avatar-uploader-icon {
      font-size: 28px;
      color: #8c939d;
      width: 178px;
      height: 178px;
      line-height: 178px;
      text-align: center;
    }
    .avatar {
      width: 178px;
      height: 178px;
      display: block;
    }
.user-search {
  margin-top: 20px;
}
.userRole {
  width: 100%;
}
</style>



// WEBPACK FOOTER //
// src/views/business/business.vue